module.exports = __webpack_public_path__ + "static/media/loading.322b2688.gif";